import { useState, useEffect } from 'react';
import api from '../api/api';

export default function DeliveryConfig() {
  const [baseFee, setBaseFee] = useState('');
  const [pricePerKm, setPricePerKm] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/admin/delivery-config')
      .then(res => {
        setBaseFee(res.data.baseFee);
        setPricePerKm(res.data.pricePerKm);
      })
      .catch(() => setError('فشل تحميل الإعدادات'));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    setError('');
    try {
      await api.put('/admin/delivery-config', {
        baseFee: parseFloat(baseFee) || 0,
        pricePerKm: parseFloat(pricePerKm) || 0,
      });
      setMessage('تم الحفظ بنجاح');
    } catch {
      setError('حدث خطأ أثناء الحفظ');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container mt-4" dir="rtl">
      <h4 className="mb-4">إعدادات رسوم التوصيل</h4>
      <form onSubmit={handleSave} style={{ maxWidth: 400 }}>
        <div className="mb-3">
          <label className="form-label">الرسوم الأساسية (SYP)</label>
          <input
            type="number"
            className="form-control"
            value={baseFee}
            onChange={e => setBaseFee(e.target.value)}
            min="0"
            step="any"
            required
          />
          <div className="form-text">رسوم ثابتة على كل طلب توصيل خارجي</div>
        </div>
        <div className="mb-3">
          <label className="form-label">السعر لكل كيلومتر (SYP)</label>
          <input
            type="number"
            className="form-control"
            value={pricePerKm}
            onChange={e => setPricePerKm(e.target.value)}
            min="0"
            step="any"
            required
          />
          <div className="form-text">يُضاف للرسوم الأساسية بحسب المسافة</div>
        </div>
        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-danger">{error}</div>}
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
        </button>
      </form>
    </div>
  );
}
